import React from 'react';
import { UserLabel } from "@aidkitorg/types/lib/survey";
import { Button, Checkbox } from '@aidkitorg/component-library';
import { useDownloadCsv, usePost } from '../API';

// This is just a way to convert the type UserLabel to an iterable object, ensuring
// TS will complain if we add something to the UserLabel type but don't update this component.
const defaultState: { [L in UserLabel]: boolean } = {
  'Primary Contact': false,
  'Program Lead': false,
  'Billing Contact': false,
  'Contract Signer': false,
};

export const DownloadUserListPage: React.FC = () => {
  const [labelState, setLabelState] = React.useState(defaultState);

  const selectedLabels = React.useMemo(() => {
    return Object.entries(labelState)
      .filter(([_, selected]) => selected)
      .map(([label]) => label);
  }, [labelState]);

  const handleClickLabel = React.useCallback((label: UserLabel) => {
    setLabelState((labelState) => ({ ...labelState, [label]: !labelState[label] }));
  }, []);

  const downloadUserList = usePost('/admin/download_user_list_across_programs');
  const { downloadCsvData } = useDownloadCsv();

  const handleClickDownload = React.useCallback(async () => {
    const userList = await downloadUserList({ labels: selectedLabels.length ? selectedLabels : null });
    downloadCsvData('users.csv', userList);
  }, [selectedLabels, downloadUserList, downloadCsvData]);

  return <>
    <h4>This downloads user data from across <b>all</b> programs</h4>
    <h5 className="mt-4">Download all users</h5>
    <Button className='mt-1' onClick={handleClickDownload}>Download</Button>
    <h5 className="mt-4">Download by user labels</h5>
    {Object.entries(labelState).map(([label, selected]) => 
      <div key={label} className="mt-2">
        <Checkbox label={label} checked={selected} onChange={() => handleClickLabel(label as UserLabel)} />
      </div>
    )}
    <Button className='mt-3' isDisabled={!selectedLabels.length} onClick={handleClickDownload}>Download</Button>
  </>;
};
